module.exports = __webpack_public_path__ + "static/media/minimize.fff27c21.svg";